import React from "react";

const InfromationSmallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
    >
      <g
        id="Group_1181"
        data-name="Group 1181"
        transform="translate(-1003.755 -375.531)"
      >
        <g
          id="Ellipse_10"
          data-name="Ellipse 10"
          transform="translate(1003.755 376.531)"
          fill="#fff"
          stroke="#404040"
          strokeWidth="1"
        >
          <circle cx="8" cy="8" r="8" stroke="none" />
          <circle cx="8" cy="8" r="7.5" fill="none" />
        </g>
        <text
          id="i"
          transform="translate(1010.194 387.531)"
          fill="#404040"
          fontSize="13"
          fontFamily="ScriptMTBold, Script MT"
        >
          <tspan x="0" y="0">
            i
          </tspan>
        </text>
      </g>
    </svg>
  );
};

export default InfromationSmallIcon;
